import { z } from 'zod';

export const GameItemTypeSchema = z.enum(['equipment_dye','prayer_candle','miracle_dye','hero_xp_boost','bag','light','med','heavy','ring','dagger','hammer','staff','sword','book','bow','shield','trinket']);

export type GameItemTypeType = `${z.infer<typeof GameItemTypeSchema>}`

export default GameItemTypeSchema;
